import React, { useEffect, useState } from "react";
import { useCallback } from "react";

export const EditSideBar = ({ steps, getCurrentComponent, stepIndex = 0 }) => {
  const [activeStep, setActiveStep] = useState(0);

  /** 🔄 Keep activeStep in sync with external stepIndex */
  // useEffect(() => {
  //   setActiveStep(stepIndex);
  // }, [stepIndex]);

  /** 🧭 Handle step click */
  const handleStepClick = useCallback(
    (index, label) => {
            setActiveStep(index);
      getCurrentComponent(label);
    },
    [getCurrentComponent]
  );

  // const handleStepClick = (stepIndex, component) => {
  //   setActiveStep(stepIndex);
  //   getCurrentComponent(component);
  // };

  useEffect(() => {
    if (stepIndex) {
      setActiveStep(stepIndex);
    }
    return () => {
      setActiveStep(0);
    };
  }, [stepIndex]);

  return (
    <div className="vertical-progress-bar">
      {steps.map((step, index) => (
        <div
          key={index}
          className={`progress-step relative cursor-pointer  ${index === activeStep ? "active" : ""
            }`}
          onClick={() => handleStepClick(index, step.label)}
        >
          <div className="flex py-2 gap-2 items-center relative z-2 text-f12 ">
            <div
              className={`step-number w-2 h-2 rounded-full ${index <= activeStep
                  ? "bg-primary text-primary"
                  : "bg-gray-300 text-disable"
                }`}
            ></div>
            <div
              className={`step-label ${index === activeStep ? "text-primary" : "text-disable"
                }`}
            >
              {step.label}
            </div>
          </div>
          {index !== steps.length - 1 && (
            <div
              className={`bg-gray-300 ${index < activeStep ? "bg-primary" : "bg-gray-300"
                } text-gray-600 progress-line absolute w-[2px] h-[2.3rem] top-[50%] z-0 left-[3px]`}
            ></div>
          )}
          {index !== steps.length - 1 && (
            <div
              className={`progress-line absolute w-[2px] h-[1.3rem] top-[50%] z-1 left-[3px]  ${index <= activeStep
                  ? "bg-primary text-white"
                  : "bg-gray-300 text-gray-600"
                }`}
            />
          )}
        </div>
      ))}
    </div>
  );
};
